
export const SET_MSG = 'AVISO_MSG';
export const SET_TRABALHADOR = 'AVISO_TRABALHADOR';
export const SET_TOMADOR = 'AVISO_TOMADOR';
export const SET_ANIVERSARIO = 'AVISO_ANIVERSARIO';
export const SET_LISTAHISTORICO = 'AVISO_LISTAHISTORICO';
